module.exports = __webpack_public_path__ + "img/drab-past.3ba151eb.jpg";